import React, { useEffect, useState } from "react";
import { DataGrid, gridClasses, GridMoreVertIcon } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { RxPlus } from "react-icons/rx";
import { IconButton, Popover, MenuItem, Checkbox } from "@mui/material";
import DeleteModal from "../../components/Model/DeleteModal";
import { HttpService } from "../../service/HttpService";
import FullScreenLoader from "../../components/Loader/FullScreenLoader";
import { TbFilterEdit } from "react-icons/tb";
import { Button } from "@mui/material";
import RankingModal from "../../components/Model/RankingModal";
import DateTimeModal from "../Schedule/ScheduleListAdd/DateTimeModal";
import { HiOutlineEye } from "react-icons/hi2";
import { GoTrash } from "react-icons/go";
import { CiEdit } from "react-icons/ci";
import { toast } from "react-toastify";
import "./clone.scss";

const Clone = () => {
  const dateFilterData = JSON.parse(localStorage.getItem("cloneDateFilter"));
  const [open, setOpen] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [clones, setClones] = useState([]);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [page, setPage] = useState(0);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().subtract(6, "day").format("MM-DD-YYYY")
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().format("MM-DD-YYYY")
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "week"
  );
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [allIds, setAllIds] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openRankingModal, setOpenRankingModal] = useState(false);
  const [rankingCloneId, setRankingCloneId] = useState(null);
  const [rankingValues, setRankingValues] = useState({
    rootsRanking: "",
    plantHealthRanking: "",
    developmentRanking: "",
  });
  const [savingRanking, setSavingRanking] = useState(false);
  const [cloneId, setCloneId] = useState("");
  const httpService = new HttpService();

  const fetchClones = async () => {
    setLoading(true);
    try {
      const res = await httpService.get(
        `motherplant/clones?page=${
          page + 1
        }&pageSize=${pageSize}&start_date=${startDate}&end_date=${endDate}&search=${searchData}`
      );
      if (res?.data?.data) {
        setClones(res?.data?.data || []);
        setRowCount(res?.data?.pagination?.total || 0);
      } else {
        setClones([]);
        setRowCount(0);
      }
    } catch (e) {
      setClones([]);
      setRowCount(0);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchClones();
  }, [page, pageSize, searchData]);

  useEffect(() => {
    const dateFilterData = JSON.parse(localStorage.getItem("cloneDateFilter"));

    if (dateFilterData && dateFilterData?.selectedRadio) {
      setStartDate(dateFilterData?.startDate);
      setEndDate(dateFilterData?.endDate);
      setSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      const cloneDateFilter = {
        startDate: dayjs().subtract(6, "day").format("MM-DD-YYYY"),
        endDate: dayjs().format("MM-DD-YYYY"),
        selectedRadio: "week",
      };
      setStartDate(cloneDateFilter?.startDate);
      setEndDate(cloneDateFilter?.endDate);
      setSelectedRadio(cloneDateFilter?.selectedRadio);
      localStorage.setItem("cloneDateFilter", JSON.stringify(cloneDateFilter));
    }
  }, []);

  const handleOpen = () => {
    setOpen(true);
    setIsAdd(true);
    setEditData({});
  };

  const handleClose = () => {
    setOpenDeleteModal(false);
    setOpen(false);
    setIsAdd(false);
    setEditData({});
    fetchClones();
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleDateTimeModal = () => {
    setOpenDateModal(false);
  };

  const handleOpenDateTimeModal = () => {
    setOpenDateModal(true);
  };

  const deleteSelectedClone = async () => {
    if (selectedId?.length > 0) {
      try {
        const response = await httpService.post("motherplant/delete_clones", {
          cloneIds: selectedId,
        });
        if (response?.success) {
          const messages = response.message;
          toast.success(messages, {
            position: "top-right",
          });
        } else {
          throw response;
        }
        setSearchData("");
        fetchClones();
        setIsAllSelected();
        setSelectedId();
        setAllIds();
        setOpenDeleteModal(false);
      } catch (error) {
        setOpenDeleteModal(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    } else {
      toast.error("Please select atleast one Record", {
        position: "top-right",
      });
    }
  };

  const formatLabel = (text) => {
    if (!text) return "";
    return text
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const isIdSelected = (id) => {
    return selectedId?.includes(id);
  };

  const toggleId = (id) => {
    setSelectedId((prev = []) => {
      if (prev.includes(id)) {
        const updatedSelectedIds = prev.filter((item) => item !== id);
        if (updatedSelectedIds.length < allIds) {
          setIsAllSelected(false);
        }
        return updatedSelectedIds;
      } else {
        const updatedSelectedIds = [...prev, id];
        if (updatedSelectedIds.length === allIds) {
          setIsAllSelected(true);
        }
        return updatedSelectedIds;
      }
    });
  };

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = clones?.map((row) => row.id); // Get all the IDs from the data
      setSelectedId(allIds); // Select all IDs
      setAllIds(allIds.length);
    } else {
      setSelectedId([]); // Deselect all
    }
    setIsAllSelected(isChecked);
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 160,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setMenuRowId(params?.row?.id);
            }}
          >
            <GridMoreVertIcon />
          </IconButton>
          {anchorEl && menuRowId === params?.row?.id && (
            <Popover
              className="popup-menu"
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  setRankingCloneId(params?.row?.id);
                  setCloneId(params?.row?.clone_id);
                  setRankingValues({
                    rootsRanking: params?.row?.root_ranking || "",
                    plantHealthRanking: params?.row?.health_ranking || "",
                    developmentRanking: params?.row?.development_ranking || "",
                  });
                  setOpenRankingModal(true);
                  handleCloseMenu();
                }}
                className="menu-list-items"
              >
                <div className="menu-list-items-text">Ranking Option</div>
              </MenuItem>
            </Popover>
          )}
        </>
      ),
    },
    // {
    //   field: "action",
    //   headerName: "Actions",
    //   headerAlign: "center",
    //   align: "center",
    //   width: 100,
    //   disableColumnMenu: true,
    //   renderCell: (params) => (
    //     <>
    //       <div className="action_icon-weap">
    //         <IconButton
    //           onClick={(e) => {
    //             handleMenuClick(e), setDataId(params.row.id);
    //           }}
    //         >
    //           <GridMoreVertIcon />
    //         </IconButton>
    //       </div>
    //       {anchorEl && dataId === params?.row?.id && (
    //         <Popover
    //           className="popup-menu"
    //           key={dataId}
    //           open={Boolean(anchorEl)}
    //           anchorEl={anchorEl}
    //           onClose={handleCloseMenu}
    //           anchorOrigin={{
    //             vertical: "bottom",
    //             horizontal: "right",
    //           }}
    //           transformOrigin={{
    //             vertical: "top",
    //             horizontal: "right",
    //           }}
    //         >
    //           <MenuItem
    //             onClick={() => {
    //               viewPage(dataId);
    //             }}
    //             className="menu-list-items"
    //           >
    //             <div className="menu-list-items-text">View</div>
    //             <HiOutlineEye style={{ cursor: "pointer" }} />
    //           </MenuItem>
    //           <MenuItem
    //             onClick={() => {
    //               // console.log("params", params.row.id);
    //               setOpenModel(true);
    //               setIsAdd(false);
    //               setInventory_Id(dataId);
    //               handleCloseMenu();
    //             }}
    //             className="menu-list-items"
    //           >
    //             <div className="menu-list-items-text">Edit</div>
    //             <CiEdit style={{ cursor: "pointer" }} />
    //           </MenuItem>
    //           <MenuItem
    //             onClick={() => {
    //               setOpenDelete(true);
    //               setDeleteInventory(dataId);
    //               handleCloseMenu();
    //             }}
    //             className="menu-list-items"
    //           >
    //             <div className="menu-list-items-text">Delete</div>
    //             <GoTrash style={{ cursor: "pointer" }} />
    //           </MenuItem>
    //         </Popover>
    //       )}
    //     </>
    //   ),
    //   sortable: false,
    // },
    // {
    //   field: "select_All",
    //   headerName: "Select All",
    //   minWidth: 150,
    //   align: "center",
    //   sortable: false,
    //   disableColumnMenu: true,
    //   renderCell: (params) => {
    //     return (
    //       <Checkbox
    //         value="Checked"
    //         checked={
    //           isAllSelected ? true : isIdSelected(params.row.id) ? true : false
    //         }
    //         onChange={() => toggleId(params.row.id)}
    //       />
    //     );
    //   },
    //   headerCheckboxSelection: true,
    //   renderHeader: (params) => {
    //     return (
    //       <>
    //         <Checkbox
    //           checked={isAllSelected}
    //           onChange={(e) => handleHeaderCheckboxChange(e)}
    //         />
    //         <strong>Select All</strong>
    //       </>
    //     );
    //   },
    // },
    { field: "cultivar", headerName: "Cultivar Name", flex: 1, minWidth: 250 },
    {
      field: "matric_id",
      headerName: "Mother Plant MATRIC ID",
      flex: 1,
      minWidth: 250,
    },
    { field: "tray_id", headerName: "Tray ID", flex: 1, minWidth: 250 },
    { field: "clone_id", headerName: "Clone ID", flex: 1, minWidth: 250 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (
        <>
          <p>{params.value === true ? "Active" : "Inactive"}</p>
        </>
      ),
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <>
          <div style={{ padding: "10px" }}>
            {params.row?.date
              ? dayjs(params.row.date).format("MM-DD-YYYY")
              : "-"}
          </div>
        </>
      ),
    },
    {
      field: "root_ranking",
      headerName: "Roots Ranking",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => <span>{params.row?.root_ranking ?? "-"}</span>,
    },
    {
      field: "health_ranking",
      headerName: "Health Ranking",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => <span>{params.row?.health_ranking ?? "-"}</span>,
    },
    {
      field: "development_ranking",
      headerName: "Development Ranking",
      flex: 1,
      minWidth: 170,
      renderCell: (params) => (
        <span>{params.row?.development_ranking ?? "-"}</span>
      ),
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 1,
    //   renderCell: (params) => (params.value ? formatLabel(params.value) : ""),
    // },
  ];

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="clone">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Clone Detail</h1>
          </div>
          <div className="button-wrap">
            {/* <button
              type="submit"
              className="btn btn-primary"
              onClick={handleOpen}
            >
              <RxPlus /> Add Clone
            </button> */}
          </div>
        </div>
        <div className="table-filter-wrap d-flex justify-content-between pb-0">
          <div className="header_search-wrap">
            <div className="header_search_bar common_content d-flex">
              <div className="input-group input_group">
                <button className="btn search-btn search_btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <circle
                      cx="9.98856"
                      cy="9.98856"
                      r="8.98856"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.2402 16.7071L19.7643 20.222"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <input
                  type="search"
                  className="form-control form_control"
                  placeholder="Search..."
                  aria-label="Search"
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchData(value);
                  }}
                />
              </div>
            </div>
          </div>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => handleOpenDateTimeModal()}
            className="filters-btn"
            style={{ textTransform: "none" }}
          >
            <TbFilterEdit /> Filters
          </Button>
        </div>
        {/* <div className="table-filter-wrap d-flex justify-content-between pb-0 pt-2">
          <Button
            className="btn btn-delete"
            onClick={() => {
              if (selectedId?.length > 0) {
                setOpenDeleteModal(true);
              } else {
                toast.error("Please select atleast one department", {
                  position: "top-right",
                });
              }
            }}
          >
            Delete
          </Button>
        </div> */}
        <div
          style={{
            height: `${clones?.length > 0 ? "" : "200px"}`,
            width: "100%",
            marginTop: 24,
          }}
        >
          <DataGrid
            rows={clones}
            columns={columns}
            loading={loading}
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize, page }}
            paginationMode="server"
            onPaginationModelChange={({ page, pageSize }) => {
              setPage(page);
              setPageSize(pageSize);
            }}
            getRowHeight={() => "auto"}
            sx={{
              border: "1px solid #E0E0E0",
              [`& .${gridClasses.cell}`]: { py: 0.5 },
            }}
            autoHeight
            showCellVerticalBorder
            showColumnVerticalBorder
          />
        </div>
        <RankingModal
          open={openRankingModal}
          onClose={() => setOpenRankingModal(false)}
          defaultValues={rankingValues}
          saving={savingRanking}
          cloneid={cloneId}
          onSubmit={async (vals) => {
            try {
              if (!rankingCloneId) return;
              setSavingRanking(true);
              await httpService.put(`motherplant/ranking/${rankingCloneId}`, {
                root_ranking: vals.rootsRanking,
                health_ranking: vals.plantHealthRanking,
                development_ranking: vals.developmentRanking,
              });
              toast.success("Ranking saved", { position: "top-right" });
              setOpenRankingModal(false);
              setRankingCloneId(null);
              setCloneId("");
              setRankingValues({
                rootsRanking: "",
                plantHealthRanking: "",
                developmentRanking: "",
              });
              fetchClones();
            } catch (e) {
              toast.error("Failed to save ranking", { position: "top-right" });
            } finally {
              setSavingRanking(false);
            }
          }}
        />
        <DeleteModal
          open={openDeleteModal}
          HandleClose={() => handleClose()}
          HandleDelete={() => {
            deleteSelectedClone();
          }}
        />
      </div>
      {/* Filter Modal Placeholder */}
      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => handleDateTimeModal()}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            fetchClones();
            const cloneDateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem(
              "cloneDateFilter",
              JSON.stringify(cloneDateFilter)
            );
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </>
  );
};

export default Clone;
